import { useCallback } from "react";
import { useDownloadNativeInvoicePdf } from "@api/native-invoice.api";
import { getNativeInvoicePdfFileName } from "@helpers/invoice";
import { useToaster } from "@design-system/ToastMessages/useToaster";

interface Params {
    workspaceId: string | undefined;
    entityId: number | undefined;
    invoiceNumber: string;
}

export function useNativeInvoicePdfDownload({
    workspaceId,
    entityId,
    invoiceNumber,
}: Params) {
    const { error } = useToaster();
    const downloadNativeInvoicePdf = useDownloadNativeInvoicePdf();

    const downloadInvoicePdf = useCallback(
        async (invoiceId: string) => {
            if (!workspaceId || entityId === undefined) {
                error("Couldn't download the PDF");
                return;
            }
            try {
                await downloadNativeInvoicePdf.mutateAsync({
                    workspaceId,
                    entityId,
                    invoiceId,
                    fileName: getNativeInvoicePdfFileName({ invoiceNumber }),
                });
            } catch {
                error("Failed to download PDF");
            }
        },
        [workspaceId, entityId, invoiceNumber, downloadNativeInvoicePdf, error],
    );

    return {
        downloadInvoicePdf,
        isDownloading: downloadNativeInvoicePdf.isPending,
    };
}
